/* eslint-disable @typescript-eslint/no-explicit-any */
import { AxiosError } from 'axios';
import { AnyAction } from 'redux-saga';
import { put } from 'redux-saga/effects';

import { displayToast } from '../redux/toast/toastSlice';

export type ErrorType = {
 title?: string;
 message?: string;
 type?: 'error' | 'warning' | 'info' | 'success';
};

export function isAxiosError(candidate: unknown): candidate is AxiosError {
 if (
  candidate &&
  typeof candidate === 'object' &&
  'isAxiosError' in candidate
 ) {
  return true;
 }
 return false;
}

export function* errorHandling(
 error: unknown | AxiosError,
 callback?: (payload: ErrorType) => AnyAction,
) {
 console.log(error);
 let output = '';
 let title = '';
 if (isAxiosError(error) || error instanceof AxiosError) {
  let message = error?.message;
  if (error?.response?.data) {
   message = `${error?.message}\r\n${JSON.stringify(error?.response?.data)}`;
  }
  if (error?.response?.data.title) {
   message = `<span style="font-weight: bold; font-size: 16px; display:block;margin-bottom: 8px;">${error?.response?.data.title}</span>${error?.message}`;
  }

  const configUrl = error?.config?.url;
  const baseURL = error?.config?.baseURL;
  const fullUrl =
   baseURL && configUrl ? `${baseURL}${configUrl}` : configUrl || baseURL;

  if (fullUrl) {
   message = `${message}\r\n${fullUrl}`;
  }

  output = message;
  title = error?.response?.data?.title as string;
 } else {
  output = `Unknown error: ${JSON.stringify(error)}`;
  title = 'Unknown error';
 }

 //  yield put(
 //   displayToast({
 //    message: output,
 //    type: 'error',
 //   }),
 //  );

 if (callback) {
  yield put(
   callback({
    title,
    message: output,
    type: 'error',
   }),
  );
 }
}
